export default "__VITE_ASSET__CsTb_j5k__"